<template>
  <div class="w-full h-full fb fb-cross-center fb-main-center">
    <div v-show="noAccess" class="fb-col-center-center c-171A1D-28">
      <span><i class="iconfont font-100">&#xe6f6;</i></span>
      <span class="mt-10">仅支持管理员、班主任、老师、家长使用</span>
    </div>
  </div>
</template>

<script>
import { appId, healthH5Url, h5Host } from '@/env'
import manageRole from '@/mixin/manageRole'
import API from '@/api'
import homeAccess from '@/mixin/homeAccess'
import {
  getTokenUrl,
  getSearchValueByKey,
  setItem,
  setLocalItem,
  getLocalItem,
  isMobile,
  getItem,
  typeofPro,
  getTitle,
  isCubePlatform,
  isEmpty,
  enterFace,
  isWxPlatform
} from '@/utils/comUtils'
import {
  LEAVE_ROLE,
  PAGE_IN_MODULE,
  DEBUGGER_CORP,
  DEBUGGERID,
  LEAVE_ROLE_NAME
} from '@/utils/constUtils'
import { mapGetters } from 'vuex'
import {
  mcOpenLink,
  mcClosePage,
  mcSetTitle,
  mcToast,
  mcShowPreloader,
  mcHidePreloader
} from '@/utils/mcSdkUtils'
import { REDIRECT_HASH } from '@/utils/noticeUtils'
export default {
  mixins: [manageRole, homeAccess],
  props: {
    sample: String
  },
  data() {
    return {
      isGray: false,
      corpId: '',
      noAccess: false,
      orgId: null,
      retryTimes: (this.$route.query || {}).retryTimes || 0,
      isFromAuth: (this.$route.query || {}).isFromAuth || false,
      moduleIdList: [],
      graybus: [],
      schoolSyncItvl: null,
      syncItvl: null,
      query: this.$route.query || {},
      platformSource: '1',
      faceSourceType: 0, // 1:ding人脸库，2：魔方人脸库 3: 拱墅人脸库
      isWxPlatform: isWxPlatform()
    }
  },
  computed: {
    ...mapGetters(['isCanChangeRole', 'currentRole', 'isCanAccess']),
    computedStudentNumber() {
      return this.$store.getters.studentNumber
    }
  },
  watch: {
    computedStudentNumber: {
      deep: true,
      immediate: true,
      handler() {
        this.$store.dispatch('guardianInitCampus')
      }
    },
    noAccess(val) {
      val && this.$root.$emit('onHideLoading')
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    let noQrCode = getSearchValueByKey('noQrCode')
    if (!this.linkHandler()) {
      return
    }
    if (isMobile || process.env.NODE_ENV !== 'production' || noQrCode === '1') {
      this.init()
    } else {
      this.$router.replace({
        path: '/qrcode',
        query: { url: window.location.href }
      })
    }
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearTimeout(this.syncItvl)
    clearTimeout(this.schoolSyncItvl)
  },
  destroyed() {},
  methods: {
    init() {
      this.login()
    },
    async loginSuccess(corpId, vehicleSearch, res) {
      if (res.result && res.result === 'XE01000500022') {
        return this.$router.replace({
          path: '/PageNoAuthotize',
          query: { msg: '未买魔点门禁' }
        })
      }
      if (res.result && res.result === 'XE01000500024') {
        return this.$router.replace({
          path: '/error',
          query: { msg: '当前系统繁忙，请稍后再试' }
        })
      }
      // 微信平台是否绑定
      const { bindState } = res || {}
      if (+bindState === 0) {
        // 保存登录token
        this.$store.commit('setToken', res)
        return this.$router.replace({
          path: '/wechat/bind',
          query: { msg: res.message }
        })
      } else if (+bindState === 2) {
        return this.$router.replace({
          path: '/wechat/empty',
          query: { type: 'noInfo', msg: res.message }
        })
      }
      if (!res.schoolInfo) {
        let _query = { ...this.query }
        const { deviceId, isActive } = _query
        return this.$router.replace({
          path: '/noSchoolInfo',
          query: { isActive: deviceId && isActive }
        })
      }
      // 家校/企业 10 待同步； 20：同步中；30同步成功；40：同步失败
      // 通讯录(未同步，同步失败)时触发通讯录同步
      if (+res.syncStatus !== 20 && +res.syncStatus !== 30) {
        API.dingStartUserSync()
      }
      // 外链跳转录脸
      let _query = { ...this.query }
      if (_query && _query.isUseFaceInput) {
        mcSetTitle('')
        this.handlerToInputFace(+_query.role)
        setTimeout(() => {
          mcClosePage()
        }, 1000)
      }
      res.saveCycle && this.$store.commit('saveCycle', res.saveCycle)
      this.$parent.updataPageView && this.$parent.updataPageView()
      this.$store.commit('headmasterClass', res.schoolInfo.headmasterClass)

      this.orgId = res.orgId
      this.$parent.$data.ifCommonLayer = true
      this.$parent.$data.isNew = true
      corpId = corpId || res.dingCorpId || ''
      this.corpId = corpId
      // 保存登录token
      this.$store.commit('setToken', res)
      setItem('corpId', corpId)
      await this.handlerGetStudentDetail(res)
      if (res.schoolInfo.isStudent) {
        await this.fetchStudentDetail([res.userid], 2)
      }
      const _ssid = decodeURIComponent(res.ssid || '') || ''
      // 访客使用
      _ssid && setItem('SESSION_ID', _ssid)
      window.localStorage.setItem('headmasterId', res.userid)
      // 获取灰度模块
      await this.getGrayMenus(corpId)
      // 获取开通的模块
      await this.getMenus()
      await this.getGrayFunction()

      // 如果有宿管 就获取宿管跨天配置
      if (this.moduleIdList.some(item => +item === PAGE_IN_MODULE.dorm)) {
        await this.getDormTransSkyConfig()
      }
      if (this.moduleIdList.some(item => +item === PAGE_IN_MODULE.familycall)) {
        try {
          const { unExpireNum = 0 } = await this.queryVideoEquityStatistics()
          this.$store.commit('setUnExpireNum', unExpireNum)
        } catch (error) {
          console.log(error)
        }
      }
      // 如果有进出校 获取设备图片
      await this.getDeviceConfigs()
      // 权限管理
      this.manageRole(res, vehicleSearch)
    },
    async loginErr(corpId, platformSource, err) {
      // 错误上报
      try {
        API.logCommand({
          corpId,
          platformSource,
          appType: 1,
          errorMsg: (err && err.message) || '未捕获到确切错误',
          page: 'pageToken'
        })
      } catch (e) {}
      if (
        (err && err.result && err.result === 'XE01000500005') ||
        (err && err.code && err.code === 'XE01000500005')
      ) {
        return this.$router.replace({
          path: '/drainage',
          query: { corpId: corpId }
        })
      } else if (err && err.code && err.code === 'XE01000500018') {
        return this.$router.replace({
          path: '/error',
          query: { msg: '企业信息未完善' }
        })
      } else {
        // err.message: null is not an object (evaluating 'res.schoolInfo.classList')
        // 免登失败
        return this.$router.replace({
          path: '/error',
          query: {
            clear: true,
            retryTimes: this.retryTimes,
            msg: (err && err.message) || '网络开小差了'
          }
        })
      }
    },
    login(vehicleSearch = '') {
      let corpId = getSearchValueByKey('corpId', vehicleSearch)
      let wechatToken = getSearchValueByKey('token', vehicleSearch) || ''
      let dingUserId = getSearchValueByKey('dingId', vehicleSearch) || ''
      const platformSource =
        getSearchValueByKey('platformSource', vehicleSearch) || '1'
      setItem('platformSource', platformSource)
      this.platformSource = platformSource
      mcSetTitle(getTitle())

      if (isEmpty(corpId, true) && !this.isWxPlatform) {
        return this.$router.replace(
          platformSource === '98' ? '/drainage' : '/error',
          { msg: '企业编号获取失败' }
        )
      }
      // 98来源无corpId
      if (platformSource === '98') {
        setItem('wechatToken', wechatToken)
        setItem('dingUserId', dingUserId)
      }
      if (this.isFromAuth) {
        const clientUserInfo = getItem('clientUserInfo')
        API.mockDingLogin({
          dingUserId: this.query.dingUserId,
          dingCorpId: corpId,
          platformSource: this.query.platformSource,
          userInfo: clientUserInfo
        })
          .then(async res => {
            this.loginSuccess(corpId, vehicleSearch, clientUserInfo)
          })
          .catch(err => {
            this.loginErr(corpId, platformSource, err)
          })
      } else {
        API.dingLogin({
          dingCorpId: corpId,
          platformSource,
          url: getTokenUrl()
        })
          .then(async res => {
            this.loginSuccess(corpId, vehicleSearch, res)
          })
          .catch(err => {
            this.loginErr(corpId, platformSource, err)
          })
      }
    },
    // 权限管理
    async manageRole(res, vehicleSearch = '') {
      // 车辆管理短链跳转逻辑
      if (vehicleSearch) {
        window.location.replace(
          `${h5Host}/#/vehiclemanage/index/managedetail?${vehicleSearch}`
        )
        return
      }
      // 学生
      if (res.schoolInfo.isStudent) {
        const platformSource = getItem('platformSource')
        // 魔方宿管机构不支持学生身份进入
        if (isCubePlatform(platformSource)) {
          this.noAccess = true
        } else {
          this.manageStudent()
        }
        return
      }
      // 外链
      let { redircetHash, redirectType, paramId } = this.query
      if (redircetHash || redirectType || paramId) {
        this.$store.dispatch('initRedircetCurrentRole')
        // 重定向处理
        this.methodRouterRedircet(res)
        return
      }
      // 微应用
      let _roleList = this.getRoleList()

      if (!_roleList.length) {
        this.chooseRole()
        return
      }

      // 调用 currentRole 时，会触发修改当前角色为本地的缓存角色；假如本地有的话
      // 因此只处理失效的即可
      // 角色列表中包含当前角色，可以先认为角色有效，具体细节的判断交于每个角色统一去处理

      if (_roleList.indexOf(this.currentRole) === -1) {
        // 失效 初始化角色
        this.$store.dispatch('initCurrentRole')
      }

      // 交于每个角色去处理

      // 家长
      if (this.currentRole === LEAVE_ROLE.guardian) {
        this.manageGuardian()
        return
      }
      // 老师
      this.manageTeacher()
    },
    async clearStorage() {
      window.localStorage.clear()
      window.sessionStorage.clear()
      await API.cancelCommand({ commands: [2] })
      ++this.retryTimes < 2 && this.init()
    },
    async handlerToInputFace(role) {
      try {
        this.faceSourceType = +(await API.getFaceSource({}))
      } catch (e) {}
      const _faceUrl = enterFace(
        this.faceSourceType,
        getSearchValueByKey('corpId'),
        role,
        appId
      )
      if (role === LEAVE_ROLE.admin) {
        // devServId=56&source=devServId 钉钉给d2配置识别参数
        mcOpenLink({
          url: _faceUrl
        })
      } else if (role === LEAVE_ROLE.guardian) {
        mcOpenLink({
          url: _faceUrl
        })
      } else {
        mcToast({ msg: '暂不支持当前角色' })
        setTimeout(() => {
          mcClosePage()
        }, 1000)
        // 暂不支持当前角色
        // this.$router.push('faceInput')
      }
    },
    async methodRouterRedircet(res) {
      let _query = {}
      // 兼容消息长度过长发送失败问题
      if (this.query.paramId) {
        const urlString = await API.getUrlByParamId({
          campusId: res.campusId,
          operUserDingId: 1, // 随便给，后端不用该字段，但是不能不传
          operUserName: 2, // 随便给，后端不用该字段，但是不能不传
          operUserRoleTypes: 3, // 随便给，后端不用该字段，但是不能不传
          orgId: this.orgId,
          paramId: this.query.paramId
        })
        const urlParams = new URLSearchParams(
          decodeURIComponent(urlString).split('#')[1].split('?')[1]
        )
        let params = {}
        for (let param of urlParams.entries()) {
          params[param[0]] = param[1]
        }
        _query = { ...params, $sourceOrigin: 'notice' }
      } else {
        _query = { ...this.query, $sourceOrigin: 'notice' }
      }

      if (_query && _query.campusId) {
        setItem('currentCapmusId', _query.campusId)
        window.localStorage.setItem('currentCapmusId', _query.campusId)
        // 外链更新出来对应校区的数据
        let totalClass = this.$store.getters.headmasterClass
        let targetClass = totalClass.find(
          item => +item.tpId === +_query.campusId
        )
        if (targetClass) {
          this.$store.commit('headmasterClass', targetClass)
        }
      }
      if (_query && _query.currentRole) {
        this.$store.commit('changeCurrentRole', +_query.currentRole)
      }
      let _role = +(_query.role || '') || +(_query.currentRole || '')
      let _type = _query.type
      if (_query.termNotNull) {
        await this.$store.dispatch('handlerCheckSemester')
      }
      // 家长角色 带校区
      if (_role === LEAVE_ROLE.guardian) {
        let student = {}
        let _stuDingId =
          _query.stuDingId ||
          _query.studentDingId ||
          _query.studentId ||
          _query.dingUserId
        const _studentList = this.$store.getters.studentList

        if (_stuDingId) {
          student = _studentList.find(v => {
            return v.studentDingId === _stuDingId
          })
        } else if (_query.campusId) {
          student = _studentList.find(v => {
            return v.campusId === _query.campusId
          })
        }
        if (!student) {
          return this.$router.replace({
            path: '/error',
            query: {
              msg: '暂无权限'
            }
          })
        }
        student.memberId &&
          this.$store.commit('studentNumber', student.memberId)
        const _canAccess = await this.judgeGuardian(student.studentDingId)
        if (!_canAccess) {
          return this.$router.replace({ path: '/home', query: {} })
        }
      }

      // 角色不需要指定 || 角色指定且为家长、班主任、管理员时，直接跳转重定向路径
      const result = await this.methodCheckRoleIsActive(res, _role, true)
      if (
        _role === -1 ||
        (Object.values(LEAVE_ROLE).includes(_role) && result) ||
        Number(_type) === 1
      ) {
        // 1. 如果需要对角色权限进行严格鉴权 链接需要携带strictAuth=1 默认无auth即松散验权
        // 2. 比如连接携带的参数是校区A的ID该角色不在A校区存在对应的角色（没有角色为-1），然后判断是否存在对当前校区的访问权限（1）
        // 3. 松散鉴权主要用来查看不需要权限校验的历史数据
        // 4. 校园安全日报周报通知-模拟自定义人员 特殊处理
        if (+_query.strictAuth) {
          // 自定义通知人员（currentRole为99）时不做权限校验
          if (typeofPro(result) === 'number' && +_query.currentRole !== 99) {
            return this.routerAsyncError(result)
          }
          this.$store.dispatch('getRoleIdList')
        }
        let _toPath = _query.redircetHash
        _toPath = REDIRECT_HASH(_query.redirectType) || _toPath
        //  角色不需要指定时删除role参数
        if (_role === -1) {
          delete _query.role
        }
        delete _query.redircetHash
        delete _query.redirectType
        this.$router.replace({
          path: window.decodeURIComponent(_toPath),
          query: _query
        })
      } else if (typeofPro(result) === 'number') {
        this.routerAsyncError(result)
      } else {
        // 角色未指定，前往角色选择界面选择角色后再行重定向到目标页面
        this.getMenus()
          .then(() => {
            this.$router.replace({ path: '/role', query: _query })
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    routerAsyncError(type, isRedirect = true) {
      if (!isRedirect && type === -1) {
        this.chooseRole()
        return
      }
      /* eslint-disable */
      this.$router.replace({
        path: '/error',
        query: {
          msg: !type
            ? '校区未创建或通讯录同步中'
            : type > 0
            ? '链接已失效'
            : '暂无权限'
        }
      })
      /* eslint-enable */
    },
    // 外链专用
    async methodCheckRoleIsActive(res, role, isRedirect) {
      const _query = this.query
      let _roleList = this.getRedircetRoleList()
      let _combineRoleList = this.getRoleList()
      // 没有符合的角色
      if (!_roleList.length) {
        return -1
      }
      // 外链跳转的角色不包含在当前角色数组内
      if (isRedirect) {
        if (role > 0 && !~_roleList.findIndex(rl => rl === role)) {
          return -1
        }
        let studentDingId =
          _query.stuDingId || _query.studentId || _query.dingUserId
        if (role === LEAVE_ROLE.guardian && studentDingId) {
          // 判断学生ID是否存在 不存在就提示失效
          const externalLink = this.$store.getters.studentList.filter(
            user => user.tpId === studentDingId
          )
          if (!externalLink.length) {
            return 1
          } else {
            this.$store.commit('studentNumber', externalLink[0].memberId)
          }
        }
      }
      let _isActve = false
      let _role = role || this.$store.getters.currentRole

      if (
        this.$store.getters.isGuardian &&
        _roleList.length === 1 &&
        (!res.schoolInfo.guardianClass || !res.schoolInfo.guardianClass.length)
      ) {
        return 0
      }

      if (~_roleList.indexOf(_role)) {
        // 家长不需要选校区
        if (_role === LEAVE_ROLE.guardian) {
          return this.setStudentNumber()
        }
        //  判断本地存储的校区信息是否有误 如果无误顺便兼容更新老数据
        let oldInfo = getLocalItem(`CURRENT_CAPMUS_${this.orgId}`) || {}
        // 存储了 判断一下
        let campus = this.getMatchedCampus()
        if (!campus || !campus.length) {
          _isActve = 0
        } else if (campus.length === 1) {
          this.$store.commit('changeCurrentCapmus', campus[0] || {})
          _isActve = true
        } else {
          const _selectCampusId = isRedirect
            ? getItem('currentCapmusId') || oldInfo.tpId
            : oldInfo.tpId
          let index = campus.findIndex(item => item.tpId === _selectCampusId)
          if (index > -1) {
            this.$store.commit('changeCurrentCapmus', campus[index] || {})
            _isActve = true
          } else {
            // 存储的校区信息失效了 重新选择
            _isActve = false
          }
        }
      } else {
        // 没有角色 先初始化判定未某个角色
        this.$store.dispatch('initCurrentRole')
        // 重新设置一下
        _role = this.$store.getters.currentRole
        // 家长不需要选校区
        if (_role === LEAVE_ROLE.guardian) {
          return this.setStudentNumber()
        }
        // 多个角色直接去选择校区
        if (_combineRoleList.length > 1) {
          // 多个角色 就到角色界面选择
          return false
        }
        // 初始化时角色为空 判断下当前用户是否只有一个角色 只有一个角色 就直接使用 如果有多个角色去选择
        if (_combineRoleList.length === 1) {
          let campus = this.getMatchedCampus()
          if (!campus || campus.length === 0) {
            _isActve = 0
          } else if (campus.length > 1) {
            // 判断之前存储的校区信息 是否包含在列表中
            _isActve = false
          } else {
            // 单校区就直接存入校区信息
            this.$store.commit('changeCurrentCapmus', campus[0] || {})
            _isActve = true
          }
        } else {
          _isActve = false
        }
      }
      return _isActve
    },
    setStudentNumber() {
      this.$store.commit('changeCurrentRole', LEAVE_ROLE.guardian)
      let studentList = this.$store.getters.studentList
      if (studentList.length) {
        if (
          !this.$store.getters.studentNumber ||
          !studentList.filter(
            v => v.memberId === this.$store.getters.studentNumber
          ).length
        ) {
          this.$store.commit('studentNumber', studentList[0].memberId)
        }
        return true
      } else {
        return 0
      }
    },
    // 模块
    getMenus() {
      return new Promise(resolve => {
        this.fetchOrgSku()
          .then(async res => {
            let _res = res || {}
            let _expireTime = +_res.expireDate - 1000 || 0
            _res.hasExpired = +new Date().getTime() >= _expireTime
            const _module =
              (_res.hasExpired ? _res.expireModuleIdList : _res.moduleIdList) ||
              []
            _res.moduleIdList = _module.reduce((_list, next) => {
              return _list.concat(`${next}`)
            }, [])
            // 班牌上架魔方 需要查询全量套餐有没有亲群通话 有的话显示留言 把对应的模块编码22写进 moduleIdList
            if (this.platformSource === '9') {
              const allRes = await API.getOrgSku2()
              const allModules = allRes.moduleIdList
              if (allModules.includes(29)) {
                _res.moduleIdList.push('22')
              }
            }
            if (
              DEBUGGER_CORP.includes(this.corpId) ||
              getItem('debugId') === DEBUGGERID
            ) {
              _res.moduleIdList.unshift(`${PAGE_IN_MODULE.auth}`)
            }
            _res.moduleIdList = [
              ...new Set([
                // 这里模拟模块 '200',
                ..._res.moduleIdList,
                ...this.graybus.join(',').split(',')
              ])
            ]
            this.$store.commit('skuInfo', _res)
            this.moduleIdList = _res.moduleIdList
            resolve()
          })
          .catch(() => (this.moduleIdList = []) && resolve())
      })
    },
    async getGrayMenus(corpId) {
      try {
        const res = await API.getSchoolGray({
          dingCorpId: corpId,
          bizTypes: []
        })
        // 接口调用失败时，存储的数据类型不正确会导致路由跳转失败
        if (res && res.message) {
          return Promise.reject(res.message)
        }
        setItem('graybus', res || [])
        this.graybus = res || []
      } catch (err) {
        console.log(err)
        setItem('graybus', [])
        this.graybus = []
        // 灰度信息获取失败，则默认为全量用户
      }
    },
    async getGrayFunction() {
      try {
        const res = await API.getOrgGrayFunctionList()
        // 接口调用失败时，存储的数据类型不正确会导致路由跳转失败
        if (res && res.message) {
          return Promise.reject(res.message)
        }
        this.$store.commit('setFunctinList', res)
      } catch (err) {
        console.log(err)
      }
    },
    // 获取学生信息
    async handlerGetStudentDetail(res) {
      if (
        res &&
        res.schoolInfo &&
        res.schoolInfo.guardianClass &&
        res.schoolInfo.guardianClass.length
      ) {
        let _classList = res.schoolInfo.guardianClass
        let _studentDingIds = []
        _classList.forEach(async item => {
          item.schoolClassDtoList &&
            item.schoolClassDtoList.length &&
            item.schoolClassDtoList.forEach(async itm => {
              if (itm.studentList && itm.studentList.length > 0) {
                _studentDingIds = _studentDingIds.concat(
                  itm.studentList.map(it => {
                    return it.tpId
                  })
                )
              }
            })
        })
        await this.fetchStudentDetail(_studentDingIds, 1)
      }
    },
    async fetchStudentDetail(studentDingIds, types) {
      await API.getStudentInfo({
        campusId: '',
        returnExtFields: [
          'accommodationTagName',
          'className',
          'gender',
          'dormName',
          'classDingId',
          'campusId',
          'deptId'
        ],
        studentDingIds: studentDingIds
      })
        .then(studentList => {
          switch (types) {
            case 1:
              let _studentList = studentList.map(student => {
                // 0 未知  1 男  2 女
                return {
                  ...student,
                  classic: student.classicCampusStudent,
                  name: student.studentName,
                  tpId: student.studentDingId,
                  classId: student.deptId,
                  tpClassId: student.classDingId,
                  dingClassesId: student.classDingId,
                  accommodationTagName: student.accommodationTagName,
                  avatarImage: require(`../assets/images/avator${student.gender}-1.png`)
                }
              })
              this.$store.commit('studentList', _studentList)
              break
            case 2:
              let student =
                (studentList && studentList.length && studentList[0]) || null
              student = {
                ...student,
                personId: student.memberId,
                personName: student.studentName,
                gradeAndClasses: student.className,
                dingClassesId: student.classDingId,
                sex: student.gender
              }
              this.$store.commit('studentDetail', student)
              this.$store.commit('studentDetailCopy', student)
              this.$store.commit('changeCurrentCapmus', {
                tpId: student.campusId
              })
              break
          }
        })
        .catch(err => {
          console.log(`pageToken`, err)
        })
    },
    // 查询模块过期时间
    fetchOrgSku() {
      return new Promise((resolve, reject) => {
        API.getOrgSku({})
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询企业同步状态
    getUserSynStatus() {
      mcShowPreloader({ text: '通讯录同步中' })
      return new Promise((resolve, reject) => {
        API.getUserSynStatus({})
          .then(res => {
            // 企业
            if (+res.status === 30) {
              mcHidePreloader()
              this.init()
            } else if (+res.status === 10 && +res.status === 40) {
              API.dingStartUserSync()
              this.getUserSynStatus()
            } else if (+res.status === 20) {
              clearTimeout(this.syncItvl)
              this.syncItvl = setTimeout(() => {
                this.getUserSynStatus()
              }, 5000)
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    // 查询家校同步状态
    getSchoolSynStatus() {
      mcShowPreloader({ text: '通讯录同步中' })
      return new Promise((resolve, reject) => {
        API.getSchoolSynStatus({})
          .then(res => {
            // 未同步成功，轮训查状态
            if (+res === 30) {
              mcHidePreloader()
              this.init()
            } else {
              clearTimeout(this.schoolSyncItvl)
              this.schoolSyncItvl = setTimeout(() => {
                this.getSchoolSynStatus()
              }, 5000)
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },
    queryVideoEquityStatistics() {
      return new Promise((resolve, reject) => {
        API.queryVideoEquityStatistics({
          operUserRoleTypes: `${this.currentRole}`,
          orgId: this.orgId
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              reject(res)
            } else {
              resolve(res)
            }
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    getDormTransSkyConfig() {
      return new Promise((resolve, reject) => {
        API.getDormTransSkyConfig({})
          .then(res => {
            this.$store.commit(
              'setSpanHour',
              res.transSky ? res.transSkyTime : 0
            )
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    // 外链专用
    getRedircetRoleList() {
      let _list = []
      let {
        isAdmin,
        isCustomRole,
        isHeadmaster,
        isTeacher,
        isDormAdmin,
        isGuardian,
        isSecurityPolicer,
        isSecurityManager,
        isBehaviorTeacher
      } = this.$store.getters

      // 管理员
      isAdmin && _list.push(LEAVE_ROLE.admin)
      // 自定义角色
      isCustomRole && _list.push(LEAVE_ROLE.customRole)
      // 班主任
      isHeadmaster && _list.push(LEAVE_ROLE.headmaster)
      // 老师
      isTeacher && _list.push(LEAVE_ROLE.teacher)
      // 宿管
      isDormAdmin && _list.push(LEAVE_ROLE.dormAdmin)
      // 安全员
      isSecurityPolicer && _list.push(LEAVE_ROLE.securityPolicer)
      // 区域负责人
      isSecurityManager && _list.push(LEAVE_ROLE.securityManager)
      // 课堂行为巡查老师
      isBehaviorTeacher && _list.push(LEAVE_ROLE.behaviorTeacher)
      // 家长
      isGuardian && _list.push(LEAVE_ROLE.guardian)

      return _list
    },
    linkHandler() {
      let { href, hash } = window.location
      // 直接跳转防疫
      if (
        +getSearchValueByKey('platformSource') === 5 ||
        getSearchValueByKey('to') === 'health'
      ) {
        window.location.replace(href.replace('campusleave', 'campushealth'))
        return false
      }
      // 不包含redirectHash 校车的通知链接参数有code 做下区分
      if (
        getSearchValueByKey('code', hash) &&
        !getSearchValueByKey('redircetHash', hash) &&
        !getSearchValueByKey('appId', hash)
      ) {
        // 校验链接有效性
        API.getCampusInfoByShortLink({
          shortLink: encodeURIComponent(href)
        })
          .then(res => {
            // 短链过期，微信平台要调整连接失效页面
            if (res && res.result === 'ME01100000001') {
              return this.$router.replace({
                path: '/wechat/empty',
                query: {
                  type: 'expired'
                }
              })
            }
            if (res && res.result && res.result !== '0') {
              return this.$Toast({ content: res.message }).show()
            }
            const params = []
            const path = res.path
            const campusId = res.campusId
            const isVehicle = [
              '/vehiclemanage/index/managedetail',
              '/vehiclemanage/manage/detail'
            ].includes(path)
            delete res.path
            Object.keys(res).forEach(key => {
              params.push(`${key}=${res[key]}`)
            })
            // 如果是车辆管理的短链，校验是否过期，未过期免登处理
            if (isVehicle) {
              API.getNotice({
                campusId,
                orgId: res.orgId,
                operUserDingId: 1, // 随便给，后端不用该字段，但是不能不传
                operUserName: 2, // 随便给，后端不用该字段，但是不能不传
                operUserRoleTypes: 3, // 随便给，后端不用该字段，但是不能不传
                shortLink: encodeURIComponent(href)
              })
                .then(res => {
                  if (res && res.result && res.result !== '0') {
                    return this.$Toast({ content: res.message }).show()
                  }
                  if (res.expired) {
                    return this.$router.push('/vehiclemanage/index/expired')
                  } else {
                    setItem('currentCapmusId', campusId)
                    params.push(`carGroupId=${res.carGroupId}`)
                    this.login(params.join('&'))
                  }
                })
                .catch(err => this.$Toast({ content: err.message }).show())
              return
            }
            const realHost =
              path === '/wechat/guidesidlist' ? `${h5Host}/` : healthH5Url
            window.location.replace(`${realHost}#${path}?${params.join('&')}`)
          })
          .catch(err => this.$Toast({ content: err.message }).show())
        return false
      }
      return true
    },
    getDeviceConfigs() {
      let config = {}
      return new Promise((resolve, _reject) => {
        API.getCustomH5Config({
          dictName: 'FACEDOOR',
          valid: 1,
          pageSize: 1000
        })
          .then(res => {
            config = res
          })
          .catch(err => {
            console.log(err)
            config = getLocalItem('CAMPUS_DEVICE_CONFIGS')
          })
          .finally(() => {
            setLocalItem('CAMPUS_DEVICE_CONFIGS', config)
            resolve(true)
          })
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    let campusId = getSearchValueByKey('campusId')
    let currentRole = getSearchValueByKey('currentRole')
    // 修复老师+家长的通知，显示undefined的问题
    const campusList = this.$store.getters.campusList
    if (+this.$store.getters.currentRole === LEAVE_ROLE.guardian) {
      this.$store.dispatch('guardianInitCampus')
    }
    if (campusId && currentRole && campusList.length) {
      this.$store.commit('changeCurrentRole', +currentRole)
      this.$store.commit(
        'changeCurrentCapmus',
        campusList.find(item => item.tpId === campusId)
      )
    }
    try {
      // 优化 只打印一遍
      console.log(
        'roleIdList',
        getItem('roleIdList'),
        getItem('roleIdList').map(v => LEAVE_ROLE_NAME[v])
      )
    } catch (error) {}
    next()
  }
}
</script>

<style scoped></style>
